'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ComposerContext } from '#pplx/frontend/composer-sdk/internal/input-state/context.js';
import { composerContainerReducer, defaultComposerContainerState, } from '#pplx/frontend/composer-sdk/internal/input-state/reducers.js';
import React, { useEffect, useMemo, useReducer } from 'react';
function areDraftStatesEqual(current, next) {
    switch (next.draftMode) {
        case 'controlled':
            return (current.draftMode === 'controlled' &&
                current.value === next.value &&
                current.onValueChange === next.onValueChange);
        case 'uncontrolled-seeded':
            return (current.draftMode === 'uncontrolled-seeded' && current.initialValue === next.initialValue);
        case 'uncontrolled':
            return current.draftMode === 'uncontrolled';
    }
}
export const ComposerProvider = React.memo(function ComposerProvider({ initialState = defaultComposerContainerState, draftState, children, }) {
    const [state, dispatch] = useReducer(composerContainerReducer, initialState);
    const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
    // Keeps the draft props in sync with reducer state after mount. `initialState`
    // seeds the reducer once; without this, later controlled value updates from
    // the consumer would never reach `useComposerState()`.
    useEffect(() => {
        if (draftState === undefined || areDraftStatesEqual(state, draftState)) {
            return;
        }
        dispatch({ type: 'SET_DRAFT_STATE', payload: draftState });
    }, [draftState, state]);
    return _jsx(ComposerContext.Provider, { value: contextValue, children: children });
});
//# sourceMappingURL=ComposerProvider.js.map